import { useMemo } from 'react';
import { apiHolder as api, apis } from 'api';
import { useContactEmailRole } from '@web-common/hooks/useContactModel';
import { useAppSelector } from '@web-common/state/createStore';
import { tabType } from '@web-common/state/reducer/mailTabReducer';
import { useContactModel } from '@web-common/hooks/useContactModel';
import useState2RM from '@web-mail/hooks/useState2ReduxMock';
const contactApi = api.api.requireLogicalApi(apis.contactApiImpl);
const systemApi = api.api.getSystemApi();
const filterUndefinedStr = (str) => {
    if (!str) {
        return '';
    }
    try {
        return str
            .replace(/undefined/g, '')
            .replace(/\s+/g, ' ')
            .trim();
    }
    catch (e) {
        console.error(e);
        return '';
    }
};
const useMailTabCompanyStr = (_model, curAccount, formList = false) => {
    var _a, _b;
    const email = _model ? contactApi.doGetModelDisplayEmail(_model) : '';
    const account = curAccount || ((_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id);
    const name = (_b = _model === null || _model === void 0 ? void 0 : _model.contact) === null || _b === void 0 ? void 0 : _b.contactName;
    const [showCustomerCompany] = useState2RM('configCustomerCompany');
    const model = useContactModel({ email, _account: account });
    const emailRole = useContactEmailRole({ email, _account: account, name });
    const currentTabType = useAppSelector(state => state.mailTabReducer.currentTab.type);
    const showStr = useMemo(() => {
        if (!showCustomerCompany) {
            return false;
        }
        if (formList) {
            return currentTabType == tabType.readMain;
        }
        return true;
    }, [currentTabType, formList, showCustomerCompany]);
    const preCompanyNames = useMemo(() => {
        var _a, _b, _c;
        if (!showCustomerCompany) {
            return '';
        }
        const customDisplayableRoles = ['myCustomer', 'colleagueCustomer', 'colleagueCustomerNoAuth', 'openSeaCustomer'];
        const clubDisplayableRoles = ['myClue', 'openSeaClue', 'colleagueClue', 'colleagueClueNoAuth'];
        if (customDisplayableRoles.includes(emailRole) || clubDisplayableRoles.includes(emailRole)) {
            let str = '';
            try {
                if (model && model.customerOrgModel && ((_b = (_a = model === null || model === void 0 ? void 0 : model.customerOrgModel) === null || _a === void 0 ? void 0 : _a.relatedCompanyInfo) === null || _b === void 0 ? void 0 : _b.length)) {
                    const list = (_c = model === null || model === void 0 ? void 0 : model.customerOrgModel) === null || _c === void 0 ? void 0 : _c.relatedCompanyInfo;
                    str = list.map(i => i.companyName || i.leadsName).join('、');
                    str += ' | ';
                }
            }
            catch (e) {
                console.error(e);
            }
            return str;
        }
        return '';
    }, [model, emailRole, showStr, showCustomerCompany]);
    return preCompanyNames;
};
export default useMailTabCompanyStr;
